/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconLocationOn from 'DesignSystem/Svgs/TysiaIconLocationOn/index'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/Addresses/Address"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let personAddressValueData = fromData.useDataFormat({ viewPath,
context: 'person_address',
format: fromFormat.format_address,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 cursor="default"
 type="secondary"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconLocationOn
{...childProps}
  viewPath={`${viewPath}/TysiaIconLocationOn`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="person_address"
 format="/Data/format.js format_address"
 text={personAddressValueData}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}